/* eslint-disable no-undef */

/* eslint-disable no-unused-vars */
var statsSlider = new Swiper('#statsSlider', {
  loop: true,
  autoplay: {
    delay: 5000
  },
  slidesPerView: 'auto',
  spaceBetween: 10,
  centeredSlides: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
});